import { call, put, all, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  infoNotification,
  showNotification,
  simpleErrorNotification,
  successNotification,
} from '../../shared-components/Notifications';
import { logout } from '../actions/auth';

export function* loadMySubscriptionPlan() {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadMySubscriptionPlan);

    yield put({
      type: resolve(types?.LOAD_MY_SUBSCRIPTION_PLAN),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MY_SUBSCRIPTION_PLAN),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MY_SUBSCRIPTION_PLAN),
        ),
      }),
    ]);
  }
}

export function* loadMySubscriptionLimit() {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadMySubscriptionPlan);

    yield put({
      type: resolve(types?.LOAD_MY_SUBSCRIPTION_LIMIT),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_MY_SUBSCRIPTION_LIMIT),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_MY_SUBSCRIPTION_LIMIT),
        ),
      }),
    ]);
  }
}

export function* loadUserPreferences() {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadPreferences);

    yield put({
      type: resolve(types?.LOAD_USER_PREFERENCES),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_USER_PREFERENCES),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_USER_PREFERENCES),
        ),
      }),
    ]);
  }
}

export function* uploadPhoto({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.uploadPhoto, {
      body: data,
      uuid: data?.uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPLOAD_PHOTO),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Photo successfully updated!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPLOAD_PHOTO),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the photo.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPLOAD_PHOTO),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPLOAD_PHOTO),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.UPLOAD_PHOTO)),
  //     }),
  //   ]);
  // }
}

export function* updateUserPreferences({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.updatePreferences, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_USER_PREFERENCES),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message:
            'Scoring model successfully updated, changes will be visible after next scoring cycle!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_USER_PREFERENCES),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Preferences change was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_USER_PREFERENCES),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message:
  //         'Scoring model successfully updated, changes will be visible after next scoring cycle!',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_USER_PREFERENCES),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_USER_PREFERENCES),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* inviteUser({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.invite, {
      uuid,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.INVITE_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Email invitation sent to user',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.INVITE_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Inviting user was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.INVITE_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       message: 'Email invitation sent to user',
  //       statusCode: 200,
  //     }),
  //   );
  // } catch (error) {
  //   showNotification(errorNotification(error, reject(types?.INVITE_USER)));
  //   yield put({
  //     type: reject(types?.INVITE_USER),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.INVITE_USER),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.INVITE_USER)),
  //     }),
  //   ]);
  // }
}

export function* loadUser() {
  try {
    const [userRes] = yield all([retry(4, 500, authClient?.User?.details)]);

    yield put({
      type: resolve(types?.LOAD_USER),
      payload: {
        user: userRes?.data(),
      },
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_USER),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_USER)),
      }),
    ]);
  }
}

export function* loadOrganization() {
  try {
    const [orgRes] = yield all([
      retry(4, 500, authClient?.User?.loadOrganization),
    ]);

    yield put({
      type: resolve(types?.LOAD_ORGANIZATION),
      payload: {
        organization: orgRes?.data(),
      },
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_ORGANIZATION),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_ORGANIZATION),
        ),
      }),
    ]);
  }
}

export function* updateUserProfile({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.updateProfile, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_USER_PROFILE),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User profile successfully updated!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_USER_PROFILE),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user profile.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_USER_PROFILE),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User profile successfully updated!',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.UPDATE_USER_PROFILE),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.UPDATE_USER_PROFILE),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* setCustomIPRangeIndicator({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.setCustomIPRangeIndicator,
      {
        body: {
          ip_range_start: data?.ipRangeStart,
          ip_range_end: data?.ipRangeEnd,
        },
      },
    );

    yield put({
      type: resolve(types?.SET_CUSTOM_IP_RANGE_INDICATOR),
      payload: res?.data(),
    });

    // showMessage({ content: 'Your range indicator was successfully updated!' });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SET_CUSTOM_IP_RANGE_INDICATOR),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.SET_CUSTOM_IP_RANGE_INDICATOR),
        ),
      }),
    ]);
  }
}

export function* loadCustomGeoIPOrganisation() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.loadCustomGeoIPOrganisation,
    );

    if (res?.data()?.count === 0) {
      const resCreateIPList = yield call(
        authClient?.User?.createCustomGeoIPList,
      );

      yield put({
        type: resolve(types?.LOAD_CUSTOM_GEO_IP_ORGANISATION),
        payload: resCreateIPList?.data(),
      });
    } else {
      yield put({
        type: resolve(types?.LOAD_CUSTOM_GEO_IP_ORGANISATION),
        payload: res?.data(),
      });
    }
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOM_GEO_IP_ORGANISATION),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOM_GEO_IP_ORGANISATION),
        ),
      }),
    ]);
  }
}

export function* loadCustomDomainIndicators() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.loadCustomDomainIndicators,
    );

    yield put({
      type: resolve(types?.LOAD_CUSTOM_DOMAIN_INDICATORS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOM_DOMAIN_INDICATORS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOM_DOMAIN_INDICATORS),
        ),
      }),
    ]);
  }
}

export function* setCustomDomainIndicators({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.setCustomDomainIndicators,
      {
        body: {
          domain: data?.domain,
          domain_type: data?.domain_type,
        },
      },
    );

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.SET_CUSTOM_DOMAIN_INDICATORS),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Your custom domain indicators were successfully updated!',
        }),
      );
      yield loadCustomDomainIndicators();
    } else {
      yield all([
        put({
          type: reject(types?.SET_CUSTOM_DOMAIN_INDICATORS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the domain indicators.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.SET_CUSTOM_DOMAIN_INDICATORS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.SET_CUSTOM_DOMAIN_INDICATORS),
  //       ),
  //     }),
  //   ]);
  // }
  // }
}

export function* deleteCustomDomainIndicators({ data }) {
  try {
    yield retry(4, 500, authClient?.User?.deleteCustomDomainIndicators, {
      uuid: data?.deleteDomainUuid,
    });

    yield put({
      type: resolve(types?.DELETE_CUSTOM_DOMAIN_INDICATORS),
      payload: data?.deleteDomainUuid,
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Your custom domain indicators were successfully deleted!',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DELETE_CUSTOM_DOMAIN_INDICATORS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.DELETE_CUSTOM_DOMAIN_INDICATORS),
        ),
      }),
    ]);
  }
}

export function* loadCustomIPRangeIndicators() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.loadCustomIPRangeIndicators,
    );
    yield put({
      type: resolve(types?.LOAD_CUSTOM_IP_RANGE_INDICATORS),
      payload: res?.data(),
    });
  } catch (error) {
    showNotification(
      errorNotification(error, reject(types?.LOAD_CUSTOM_IP_RANGE_INDICATORS)),
    );

    yield put({
      type: reject(types?.LOAD_CUSTOM_IP_RANGE_INDICATORS),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_CUSTOM_IP_RANGE_INDICATORS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_CUSTOM_IP_RANGE_INDICATORS),
        ),
      }),
    ]);
  }
}

export function* setCustomIPRangeIndicators({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.setCustomIPRangeIndicators,
      {
        body: {
          ip_range_start: data?.ip_range_start,
          ip_range_end: data?.ip_range_end,
        },
      },
    );
    yield put({
      type: resolve(types?.SET_CUSTOM_IP_RANGE_INDICATORS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Indicators was successfully created!',
      }),
    );
  } catch (error) {
    showNotification(
      simpleErrorNotification({
        statusCode: 400,
        message:
          'An error has occurred while creating the custom IP range indicators.',
      }),
    );

    yield put({
      type: reject(types?.SET_CUSTOM_IP_RANGE_INDICATORS),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
      }),
    ]);
  }
}
export function* updateCustomIPRangeIndicators({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.updateCustomIPRangeIndicators,
      {
        body: {
          ip_range_start: data?.ip_range_start,
          ip_range_end: data?.ip_range_end,
        },
        uuid: data?.uuid,
      },
    );
    yield put({
      type: resolve(types?.UPDATE_CUSTOM_IP_RANGE_INDICATORS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Indicators was successfully updated!',
      }),
    );
  } catch (error) {
    showNotification(
      simpleErrorNotification({
        statusCode: 503,
        message:
          'An error has occurred while updating the custom IP range indicators.',
      }),
    );

    yield put({
      type: reject(types?.UPDATE_CUSTOM_IP_RANGE_INDICATORS),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
      }),
    ]);
  }
}
export function* deleteCustomIPRangeIndicators({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.User?.deleteCustomIPRangeIndicators,
      {
        uuid: data?.uuid,
      },
    );
    yield put({
      type: resolve(types?.DELETE_CUSTOM_IP_RANGE_INDICATORS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Indicators was successfully deleted!',
      }),
    );
  } catch (error) {
    showNotification(
      simpleErrorNotification({
        statusCode: 503,
        message:
          'An error has occurred while deleting the custom IP range indicators.',
      }),
    );

    yield put({
      type: reject(types?.DELETE_CUSTOM_IP_RANGE_INDICATORS),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
      }),
    ]);
  }
}

export function* loadCustomGeoIP({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadCustomGeoIP, {
      uuid,
    });

    yield put({
      type: resolve(types?.LOAD_CUSTOM_GEO_IP),
      payload: res?.data(),
    });
  } catch (error) {
    showNotification(errorNotification(error, reject(types?.LOAD_FILTERS)));

    yield put({
      type: reject(types?.LOAD_CUSTOM_GEO_IP),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
      }),
    ]);
  }
}

export function* setCustomGeoIP({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.setCustomGeoIP, {
      body: {
        geo_ip_list: data?.geoIPList,
      },
      uuid: data?.customGeoIPOrganisationUUID,
    });

    yield put({
      type: resolve(types?.SET_CUSTOM_GEO_IP),
      payload: res?.data(),
    });

    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Your geo ip list was successfully updated!',
      }),
    );
  } catch (error) {
    showNotification(errorNotification(error, reject(types?.LOAD_FILTERS)));

    yield put({
      type: reject(types?.SET_CUSTOM_GEO_IP),
      error,
    });
    yield all([
      put({
        type: reject(types?.LOAD_FILTERS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
      }),
    ]);
  }
}

export function* changePassword({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.changePassword, {
      body: {
        current_password: data?.oldPassword,
        new_password: data?.newPassword,
        re_new_password: data?.confirmNewPassword,
      },
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CHANGE_PASSWORD),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Your password was successfully updated!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CHANGE_PASSWORD),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Password change was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CHANGE_PASSWORD),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Your password was successfully updated!',
  //     }),
  //   );
  //   logout();
  // } catch (error) {
  //   showNotification(
  //     simpleErrorNotification({
  //       statusCode: 503,
  //       message: 'An error has occurred while updating the password.',
  //     }),
  //   );
  //   yield put({
  //     type: reject(types?.CHANGE_PASSWORD),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* updateOrganization({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.updateOrganization, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_USER_ORGANIZATION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Organization successfully updated!',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_USER_ORGANIZATION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the organization.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_USER_ORGANIZATION),
  //     payload: res?.data(),
  //   });

  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Organization successfully updated!',
  //     }),
  //   );
  // } catch (error) {
  //   showNotification(
  //     simpleErrorNotification({
  //       statusCode: 503,
  //       message: 'An error has occurred while updating the organization.',
  //     }),
  //   );
  //   yield put({
  //     type: reject(types?.UPDATE_USER_ORGANIZATION),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* loadUsers() {
  try {
    const res = yield retry(4, 500, authClient?.User?.list);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_USERS),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Email invitation sent to user',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_USERS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while loading users data.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_USERS),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield put({
  //     type: reject(types?.LOAD_USERS),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* loadUsersInfo() {
  try {
    const res = yield retry(4, 500, authClient?.User?.loadUsersInfo);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_USERS_INFO),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Email invitation sent to user',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_USERS_INFO),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while loading users data.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_USERS_INFO),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield put({
  //     type: reject(types?.LOAD_USERS_INFO),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_USERS_INFO),
  //       error,
  //     }),
  //   ]);
  // }
}

export function* createUser({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.create, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.CREATE_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Email invitation sent to user',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.CREATE_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while adding the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.CREATE_USER),
  //     payload: res?.data(),
  //   });
  //   const error = JSON.parse(res.responseData)['error'];
  //   if (error) {
  //     showNotification(
  //       infoNotification({
  //         statusCode: 100,
  //         message: error,
  //       }),
  //     );
  //   } else {
  //     showNotification(
  //       successNotification({
  //         statusCode: 200,
  //         message: 'Email invitation sent to user',
  //       }),
  //     );
  //   }
  // } catch (error) {
  //   showNotification(
  //     simpleErrorNotification({
  //       statusCode: 503,
  //       message: 'An error has occurred while adding the user.',
  //     }),
  //   );
  //   yield put({
  //     type: reject(types?.CREATE_USER),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* deleteUser({ user }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.delete, {
      id: user?.username,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.DELETE_USER),
        id: user?.username,
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User has been deleted',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.DELETE_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while deleting the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.DELETE_USER),
  //     id: user?.username,
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User has been deleted',
  //     }),
  //   );
  // } catch (error) {
  //   showNotification(
  //     simpleErrorNotification({
  //       statusCode: 503,
  //       message: 'An error has occurred while deleting the user.',
  //     }),
  //   );
  //   yield put({
  //     type: reject(types?.DELETE_USER),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* updateUser({ user }) {
  try {
    const res = yield retry(4, 500, authClient?.User?.update, {
      id: user?.username,
      body: user,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.UPDATE_USER),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'User has been updated',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.UPDATE_USER),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'An error has occurred while updating the user.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.UPDATE_USER),
  //     payload: res?.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'User has been updated',
  //     }),
  //   );
  // } catch (error) {
  //   showNotification(
  //     simpleErrorNotification({
  //       statusCode: 503,
  //       message: 'An error has occurred while updating the user.',
  //     }),
  //   );
  //   yield put({
  //     type: reject(types?.UPDATE_USER),
  //     error,
  //   });
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_FILTERS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_FILTERS)),
  //     }),
  //   ]);
  // }
}

export function* setWebsocketConnection({ websocketConnection }) {
  try {
    yield put({
      type: resolve(types?.SET_WEBSOCKET_CONNECTION),
      payload: websocketConnection,
    });
  } catch (error) {}
}

export function* setWebsocketConnectionStatus({ websocketConnectionStatus }) {
  try {
    yield put({
      type: resolve(types?.SET_WEBSOCKET_CONNECTION_STATUS),
      payload: websocketConnectionStatus,
    });
  } catch (error) {}
}
